import { Skeleton } from '@/components/UI/Skeleton'
import { SPOT_FILTER_ROW_CLASS } from './SpotFilterRow'

type Props = {
  /** タグ Pill のスケルトン個数（デフォルト: 3） */
  tagCount?: number
}

/** タグ Pill スケルトンの幅（px）。タグ名の長さのばらつきを表現するため固定パターンで回す */
const TAG_WIDTHS = [64, 72, 56] as const

/**
 * SpotFilterRow の形状に合わせたスケルトン。
 * PillSelect（コース選択）1 個 + タグ Pill を横並びにする。
 * 行のクラスは SpotFilterRow から共有する。
 *
 * NOTE: 高さ 24px は PillSelect.module.css / Pill.module.css（.inactive）に合わせている。変更時は追従すること。
 */
export function SpotFilterRowSkeleton({ tagCount = 3 }: Props) {
  return (
    <div
      data-testid="spot-filter-row-skeleton"
      aria-hidden="true"
      className={`${SPOT_FILTER_ROW_CLASS} overflow-hidden`}
    >
      {/* PillSelect（「すべてのコース ▼」） */}
      <Skeleton variant="rect" width={120} height={24} className="shrink-0 rounded-full" />
      {/* タグ Pill */}
      {Array.from({ length: tagCount }).map((_, i) => (
        <Skeleton
          // biome-ignore lint/suspicious/noArrayIndexKey: 静的なスケルトンのため index を key に使用
          key={i}
          variant="rect"
          width={TAG_WIDTHS[i % TAG_WIDTHS.length]}
          height={24}
          className="shrink-0 rounded-full"
        />
      ))}
    </div>
  )
}
